import { formatCryptoPrice } from '@/lib/format';
import { CandlestickData } from 'lightweight-charts';

interface CrosshairInfoProps {
  data: CandlestickData;
}

interface PriceItemProps {
  label: string;
  value: number;
  color: string;
}

const PriceItem = ({ label, value, color }: PriceItemProps) => (
  <div className="flex items-center">
    <span className="text-primaryTextColor">{label}</span>
    <span className="ml-1" style={{ color }}>
      {formatCryptoPrice(value)}
    </span>
  </div>
);

export default ({ data }: CrosshairInfoProps) => {
  const { open, high, low, close } = data;
  const color = close >= open ? '#F57379' : '#66D8A0';

  const priceItems = [
    { label: 'O', value: open },
    { label: 'H', value: high },
    { label: 'L', value: low },
    { label: 'C', value: close },
  ];

  return (
    <div className="absolute left-2.5 top-2.5 z-10 flex flex-wrap gap-x-2.5 text-xs">
      {priceItems.map(({ label, value }) => (
        <PriceItem key={label} label={label} value={value} color={color} />
      ))}
    </div>
  );
};
